export function htmlInflow() {
  return (
    <>
      <hr />
      <h5>Entrada de Recursos</h5>
      <p>
        São todas entradas de valores na conta do Usuário, independentemente se
        haverão custas, taxas, comissões que consumirão parte, ou totalmente o
        valor.
        <br />
        Se resume no valor bruto das atividades do Usuário proprietário de
        Campanhas, Afiliados, etc...
        <br />
        Algumas das possibilidades desta serão listadas abaixo:
      </p>

      {/* Ticket Sale */}
      <h5 className="fw-bold">1. Venda de Tickets em uma Campanha (Rifa)</h5>
      <p>
        Ao vender Tickets (Bilhetes) em uma Campanha, este valor entra em sua
        conta como Entrada de Recursos, mas nem sempre estará liberado
        integralmente para uso pois dependendo do plano adquirido da Campanha,
        pode haver encargos, alguns deste seguem abaixo:
      </p>
      <ul>
        <li>
          <strong>Taxa da Plataforma:</strong> Caso o plano da Campanha divida
          um percentual da venda do Ticket, estas taxas serão subtraídas deste
          recurso.
        </li>
        <li>
          <strong>Taxa Externa:</strong> Na maioria dos planos de Campanha há
          taxas externas que são de serviços de terceiros (Gateways), como
          processadores de pagamento, etc...
        </li>
        <li>
          <strong>Comissões:</strong> Caso sua Campanha conte com Parceiros e/ou
          Afiliados, a comissão deste também será subtraída do recurso em
          questão.
        </li>
      </ul>

      {/* Commissions */}
      <h5 className="fw-bold">2. Comissões</h5>
      <p>
        Ao se Afiliar ou ser Parceiro em alguma Campanha, suas comissões também
        serão classificadas como Entrada de Recursos em sua conta.
      </p>

      <p>
        É importante compreender o funcionamento do financeiro e, caso haja
        quaisquer dúvidas, contate nosso suporte.
      </p>
    </>
  );
}
